/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddEditEmployeeDto } from '../models/add-edit-employee-dto';
import { apiEmployeeActivatePut } from '../fn/employee/api-employee-activate-put';
import { ApiEmployeeActivatePut$Params } from '../fn/employee/api-employee-activate-put';
import { apiEmployeeAllGet } from '../fn/employee/api-employee-all-get';
import { ApiEmployeeAllGet$Params } from '../fn/employee/api-employee-all-get';
import { apiEmployeeCheckBarcodeGet } from '../fn/employee/api-employee-check-barcode-get';
import { ApiEmployeeCheckBarcodeGet$Params } from '../fn/employee/api-employee-check-barcode-get';
import { apiEmployeeCheckEmailGet } from '../fn/employee/api-employee-check-email-get';
import { ApiEmployeeCheckEmailGet$Params } from '../fn/employee/api-employee-check-email-get';
import { apiEmployeeCheckPinGet } from '../fn/employee/api-employee-check-pin-get';
import { ApiEmployeeCheckPinGet$Params } from '../fn/employee/api-employee-check-pin-get';
import { apiEmployeeCheckUsernameGet } from '../fn/employee/api-employee-check-username-get';
import { ApiEmployeeCheckUsernameGet$Params } from '../fn/employee/api-employee-check-username-get';
import { apiEmployeeDeactivatePut } from '../fn/employee/api-employee-deactivate-put';
import { ApiEmployeeDeactivatePut$Params } from '../fn/employee/api-employee-deactivate-put';
import { apiEmployeeDropdownOptionsGet } from '../fn/employee/api-employee-dropdown-options-get';
import { ApiEmployeeDropdownOptionsGet$Params } from '../fn/employee/api-employee-dropdown-options-get';
import { apiEmployeeGiveMultipleKioskTransactionsPermissionPost } from '../fn/employee/api-employee-give-multiple-kiosk-transactions-permission-post';
import { ApiEmployeeGiveMultipleKioskTransactionsPermissionPost$Params } from '../fn/employee/api-employee-give-multiple-kiosk-transactions-permission-post';
import { apiEmployeeGiveRecordDeletionPermissionPost } from '../fn/employee/api-employee-give-record-deletion-permission-post';
import { ApiEmployeeGiveRecordDeletionPermissionPost$Params } from '../fn/employee/api-employee-give-record-deletion-permission-post';
import { apiEmployeeGuidGet } from '../fn/employee/api-employee-guid-get';
import { ApiEmployeeGuidGet$Params } from '../fn/employee/api-employee-guid-get';
import { apiEmployeePut } from '../fn/employee/api-employee-put';
import { ApiEmployeePut$Params } from '../fn/employee/api-employee-put';
import { apiEmployeeRegisterPost } from '../fn/employee/api-employee-register-post';
import { ApiEmployeeRegisterPost$Params } from '../fn/employee/api-employee-register-post';
import { apiEmployeeRemoveMultipleKioskTransactionsPermissionPost } from '../fn/employee/api-employee-remove-multiple-kiosk-transactions-permission-post';
import { ApiEmployeeRemoveMultipleKioskTransactionsPermissionPost$Params } from '../fn/employee/api-employee-remove-multiple-kiosk-transactions-permission-post';
import { apiEmployeeRemoveRecordDeletionPermissionPost } from '../fn/employee/api-employee-remove-record-deletion-permission-post';
import { ApiEmployeeRemoveRecordDeletionPermissionPost$Params } from '../fn/employee/api-employee-remove-record-deletion-permission-post';
import { DropDownDto } from '../models/drop-down-dto';
import { EmployeeDto } from '../models/employee-dto';
import { NotificationMessage } from '../models/notification-message';

@Injectable({ providedIn: 'root' })
export class EmployeeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiEmployeeCheckUsernameGet()` */
  static readonly ApiEmployeeCheckUsernameGetPath = '/api/employee/check-username';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeCheckUsernameGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeCheckUsernameGet$Response(params?: ApiEmployeeCheckUsernameGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiEmployeeCheckUsernameGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeCheckUsernameGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeCheckUsernameGet(params?: ApiEmployeeCheckUsernameGet$Params, context?: HttpContext): Observable<void> {
    return this.apiEmployeeCheckUsernameGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiEmployeeCheckEmailGet()` */
  static readonly ApiEmployeeCheckEmailGetPath = '/api/employee/check-email';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeCheckEmailGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeCheckEmailGet$Response(params?: ApiEmployeeCheckEmailGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiEmployeeCheckEmailGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeCheckEmailGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeCheckEmailGet(params?: ApiEmployeeCheckEmailGet$Params, context?: HttpContext): Observable<void> {
    return this.apiEmployeeCheckEmailGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiEmployeeCheckBarcodeGet()` */
  static readonly ApiEmployeeCheckBarcodeGetPath = '/api/employee/check-barcode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeCheckBarcodeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeCheckBarcodeGet$Response(params?: ApiEmployeeCheckBarcodeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiEmployeeCheckBarcodeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeCheckBarcodeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeCheckBarcodeGet(params?: ApiEmployeeCheckBarcodeGet$Params, context?: HttpContext): Observable<void> {
    return this.apiEmployeeCheckBarcodeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiEmployeeCheckPinGet()` */
  static readonly ApiEmployeeCheckPinGetPath = '/api/employee/check-pin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeCheckPinGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeCheckPinGet$Response(params?: ApiEmployeeCheckPinGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiEmployeeCheckPinGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeCheckPinGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeCheckPinGet(params?: ApiEmployeeCheckPinGet$Params, context?: HttpContext): Observable<void> {
    return this.apiEmployeeCheckPinGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiEmployeeRegisterPost()` */
  static readonly ApiEmployeeRegisterPostPath = '/api/employee/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeRegisterPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeRegisterPost$Response(params?: ApiEmployeeRegisterPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiEmployeeRegisterPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeRegisterPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeRegisterPost(params?: ApiEmployeeRegisterPost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiEmployeeRegisterPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiEmployeeActivatePut()` */
  static readonly ApiEmployeeActivatePutPath = '/api/employee/activate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeActivatePut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeActivatePut$Response(params?: ApiEmployeeActivatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiEmployeeActivatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeActivatePut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeActivatePut(params?: ApiEmployeeActivatePut$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiEmployeeActivatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiEmployeeDeactivatePut()` */
  static readonly ApiEmployeeDeactivatePutPath = '/api/employee/deactivate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeDeactivatePut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeDeactivatePut$Response(params?: ApiEmployeeDeactivatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiEmployeeDeactivatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeDeactivatePut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeDeactivatePut(params?: ApiEmployeeDeactivatePut$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiEmployeeDeactivatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiEmployeeAllGet()` */
  static readonly ApiEmployeeAllGetPath = '/api/employee/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeAllGet$Response(params?: ApiEmployeeAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeDto>>> {
    return apiEmployeeAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeAllGet(params?: ApiEmployeeAllGet$Params, context?: HttpContext): Observable<Array<EmployeeDto>> {
    return this.apiEmployeeAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EmployeeDto>>): Array<EmployeeDto> => r.body)
    );
  }

  /** Path part for operation `apiEmployeeGuidGet()` */
  static readonly ApiEmployeeGuidGetPath = '/api/employee/{guid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeGuidGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeGuidGet$Response(params: ApiEmployeeGuidGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AddEditEmployeeDto>> {
    return apiEmployeeGuidGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeGuidGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeGuidGet(params: ApiEmployeeGuidGet$Params, context?: HttpContext): Observable<AddEditEmployeeDto> {
    return this.apiEmployeeGuidGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddEditEmployeeDto>): AddEditEmployeeDto => r.body)
    );
  }

  /** Path part for operation `apiEmployeePut()` */
  static readonly ApiEmployeePutPath = '/api/employee';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeePut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeePut$Response(params?: ApiEmployeePut$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiEmployeePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeePut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeePut(params?: ApiEmployeePut$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiEmployeePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiEmployeeDropdownOptionsGet()` */
  static readonly ApiEmployeeDropdownOptionsGetPath = '/api/employee/dropdown-options';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeDropdownOptionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeDropdownOptionsGet$Response(params?: ApiEmployeeDropdownOptionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DropDownDto>>> {
    return apiEmployeeDropdownOptionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeDropdownOptionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiEmployeeDropdownOptionsGet(params?: ApiEmployeeDropdownOptionsGet$Params, context?: HttpContext): Observable<Array<DropDownDto>> {
    return this.apiEmployeeDropdownOptionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DropDownDto>>): Array<DropDownDto> => r.body)
    );
  }

  /** Path part for operation `apiEmployeeGiveRecordDeletionPermissionPost()` */
  static readonly ApiEmployeeGiveRecordDeletionPermissionPostPath = '/api/employee/give-record-deletion-permission';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeGiveRecordDeletionPermissionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeGiveRecordDeletionPermissionPost$Response(params?: ApiEmployeeGiveRecordDeletionPermissionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiEmployeeGiveRecordDeletionPermissionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeGiveRecordDeletionPermissionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeGiveRecordDeletionPermissionPost(params?: ApiEmployeeGiveRecordDeletionPermissionPost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiEmployeeGiveRecordDeletionPermissionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiEmployeeRemoveRecordDeletionPermissionPost()` */
  static readonly ApiEmployeeRemoveRecordDeletionPermissionPostPath = '/api/employee/remove-record-deletion-permission';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeRemoveRecordDeletionPermissionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeRemoveRecordDeletionPermissionPost$Response(params?: ApiEmployeeRemoveRecordDeletionPermissionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiEmployeeRemoveRecordDeletionPermissionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeRemoveRecordDeletionPermissionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeRemoveRecordDeletionPermissionPost(params?: ApiEmployeeRemoveRecordDeletionPermissionPost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiEmployeeRemoveRecordDeletionPermissionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiEmployeeGiveMultipleKioskTransactionsPermissionPost()` */
  static readonly ApiEmployeeGiveMultipleKioskTransactionsPermissionPostPath = '/api/employee/give-multiple-kiosk-transactions-permission';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeGiveMultipleKioskTransactionsPermissionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeGiveMultipleKioskTransactionsPermissionPost$Response(params?: ApiEmployeeGiveMultipleKioskTransactionsPermissionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiEmployeeGiveMultipleKioskTransactionsPermissionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeGiveMultipleKioskTransactionsPermissionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeGiveMultipleKioskTransactionsPermissionPost(params?: ApiEmployeeGiveMultipleKioskTransactionsPermissionPost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiEmployeeGiveMultipleKioskTransactionsPermissionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiEmployeeRemoveMultipleKioskTransactionsPermissionPost()` */
  static readonly ApiEmployeeRemoveMultipleKioskTransactionsPermissionPostPath = '/api/employee/remove-multiple-kiosk-transactions-permission';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiEmployeeRemoveMultipleKioskTransactionsPermissionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeRemoveMultipleKioskTransactionsPermissionPost$Response(params?: ApiEmployeeRemoveMultipleKioskTransactionsPermissionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiEmployeeRemoveMultipleKioskTransactionsPermissionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiEmployeeRemoveMultipleKioskTransactionsPermissionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiEmployeeRemoveMultipleKioskTransactionsPermissionPost(params?: ApiEmployeeRemoveMultipleKioskTransactionsPermissionPost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiEmployeeRemoveMultipleKioskTransactionsPermissionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

}
